import { CustomError } from '../../framework/utils/errors';

export class ValidationError extends CustomError {
  constructor(message: string) {
    super(message, 400);
    this.name = 'ValidationError';
  }
}

export class NotFoundError extends CustomError {
  constructor(message: string) {
    super(message, 404);
    this.name = 'NotFoundError';
  }
}

export class UnauthorizedError extends CustomError {
  constructor(message?: string) {
    super(message ?? 'Unauthorized', 401);
    this.name = 'UnauthorizedError';
  }
}

export class BadRequestError extends CustomError {
  constructor(message?: string) {
    super(message ?? 'Bad Request', 400);
    this.name = 'BadRequestError';
  }
}
